import { CAPGUARD_PORT_TYPES, getModelOptions } from "./OrderForm.options";
import type { Portfolio } from "@/api/types";

export type InternalTransferOrder = {
  id: string;
  portfolioId: string;
  portType?: string;
  modelType?: string;
  modelName?: string;
};

export type InternalTransferTarget = {
  id: string;
  shortName: string;
  name: string;
  modelName: string;
};

export function getPendingInternalTransferTargets(
  orders: InternalTransferOrder[],
  excludedOrderId?: string
): InternalTransferTarget[] {
  return orders
    .filter(
      (order) =>
        order.id !== excludedOrderId &&
        order.portfolioId === "NEW" &&
        CAPGUARD_PORT_TYPES.includes(order.portType ?? "")
    )
    .map((order) => ({
      id: order.id,
      shortName: "New portfolio",
      name: "New portfolio",
      modelName: order.modelName ||
        getModelOptions(order.portType ?? "").find((option) => option.value === order.modelType)?.label ||
        order.modelType ||
        "Ingen modell",
    }));
}

export function getInternalTransferTargets(
  portfolios: Portfolio[],
  sourceId: string,
  orders: InternalTransferOrder[],
  excludedOrderId?: string
): InternalTransferTarget[] {
  const source = portfolios.find(
    (portfolio) => String(portfolio.id) === sourceId
  );
  if (!source?.shortName?.startsWith("2")) return [];
  return [
    ...portfolios
      .filter(
        (portfolio) =>
          portfolio.status === "A" &&
          portfolio.shortName?.startsWith("2") &&
          String(portfolio.id) !== sourceId
      )
      .map((portfolio) => ({
        id: String(portfolio.id),
        shortName: portfolio.shortName,
        name: portfolio.name,
        modelName: portfolio.modelPortfolio?.linkedPortfolio?.name ||
          portfolio.modelPortfolio?.name ||
          "Ingen modell",
      })),
    ...getPendingInternalTransferTargets(orders, excludedOrderId),
  ];
}
